'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ViewLandingPageEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { CountryCode } from '@marketplace-web/country/country-data'

import SecondhandTaxesComponentsRenderer from './components/SecondhandTaxesComponentsRenderer'
import useSecondhandTaxesPageContent from './hooks/useSecondhandTaxesPageContent'
import { NO_CHANGES_TO_TAXES_URL } from '../../constants/routes'

type Props = { countryCode: CountryCode }

const SecondhandTaxes = ({ countryCode }: Props) => {
  const content = useSecondhandTaxesPageContent(countryCode)
  const { track } = useTracking()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: 'no_changes_to_taxes',
        path: NO_CHANGES_TO_TAXES_URL,
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  if (!content) return null

  return <SecondhandTaxesComponentsRenderer content={content} />
}

export default SecondhandTaxes
